import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {ActionsRow, DetailValue, Loader, modal, utils} from "@mc/mc-legacy";
import * as React from "react";
import {Component} from "react";
import {Button, ButtonToolbar, Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import {getUplnaAdresa} from "../utils/adresaFormatter";
import DopravaPlatbaForm from "../forms/operator/DopravaPlatbaForm";
import * as objednavkaActions from "../actions/objednavkaActions";
import * as ciselnikActions from "../actions/ciselnikActions";
import * as EnumFormaDoruceni from "../api/gen/cgo/EnumFormaDoruceni";
import ObjednavkaApi from "../api/gen/cgo/ObjednavkaApi";
import {formatDate, formatTime, getMaximalniCas, getMinimalniCas, timeStringToDate} from "../utils/utils";
import ObjednavkaDopravyForm from "../forms/operator/ObjednavkaDopravyForm";
import {TIME_STEP} from "../const/const";
import {withTranslation, WithTranslation} from "react-i18next";

const {storeFromArea} = utils;

/**
 * Panel zobrazující informace o dopravě a platbě objednávky.
 */
class DopravaPlatbaPanel extends Component<WithTranslation> {

    static propTypes = {
        objednavka: PropTypes.object.isRequired, // VO objednávky
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        const {objednavka} = this.props;
        this.props.dispatch(ciselnikActions.fetchFirmaIfNeeded());
        this.props.dispatch(ciselnikActions.fetchZpusobyDopravyIfNeeded());
        this.props.dispatch(ciselnikActions.fetchZpusobyPlatbyIfNeeded());
        this.props.dispatch(ciselnikActions.fetchPobockyOperatorIfNeeded());
        this.props.dispatch(objednavkaActions.fetchObjednavkaUzivatelAdresyIfNeeded(objednavka.uzivatelObjednalId));
        this.props.dispatch(objednavkaActions.fetchObjednavkaRightsIfNeeded(objednavka.id));
        if (objednavka.zpusobDopravaId) {
            this.props.dispatch(ciselnikActions.fetchTerminyDopravyIfNeeded(objednavka.zpusobDopravaId));
        }
        if (objednavka.spolecnostId) {
            this.props.dispatch(objednavkaActions.fetchObjednavkaSpolecnostAdresyIfNeeded(objednavka.spolecnostId));
        }
    };

    handleUpravit = () => {
        const {zpusobyDopravyList, zpusobyPlatbyList, pobockyList, adresyUzivatelList,
            adresySpolecnostList, firmaDetail, t} = this.props;
        const objednavka = this.props.objednavka;

        let adresyList;
        if (adresyUzivatelList.fetched) {
            adresyList = adresyUzivatelList.rows;
        }
        if (adresySpolecnostList.fetched) {
            adresyList = [...adresyList, ...adresySpolecnostList.rows];
        }

        const zpusobDopravy = objednavka.zpusobDopravaId && zpusobyDopravyList.rows.find(z => z.id === objednavka.zpusobDopravaId);
        const naPobocku = zpusobDopravy && zpusobDopravy.formaDoruceni === EnumFormaDoruceni.POB;
        const pobocka = naPobocku && objednavka.pobockaId ? pobockyList.rows.find(x => x.id === objednavka.pobockaVznikId) : null;

        const initialValues = {
            adresa: objednavka.adresaId ? adresyList.find(a => a.id === objednavka.adresaId) : null,
            zpusobDopravaId: objednavka.zpusobDopravaId ? objednavka.zpusobDopravaId.toString() : null, // radio input zatim neumí integer
            zpusobPlatbaId: objednavka.zpusobPlatbaId ? objednavka.zpusobPlatbaId.toString() : null, // radio input zatim neumí integer
            ulice: objednavka.ulice,
            obec: objednavka.obec,
            psc: objednavka.psc,
            stat: objednavka.stat,
            datumVyzvednuti: objednavka.datumVyzvednuti,
            datumDoruceni: objednavka.datumDoruceni,
            casVyzvednuti: objednavka.casVyzvednuti ? formatTime(objednavka.casVyzvednuti) : null,
            terminDopravaId: objednavka.terminDopravaId,
            pobockaVznikId: objednavka.pobockaVznikId ? objednavka.pobockaVznikId.toString() : null,
            naPobocku: naPobocku,
        };

        this.props.dispatch(modal.ModalActions.show(
            DopravaPlatbaForm,
            {
                onSubmit: (data) => {
                    const result = {
                        zpusobPlatbaId: data.zpusobPlatbaId ? parseInt(data.zpusobPlatbaId) : null,
                        zpusobDopravaId: data.zpusobDopravaId ? parseInt(data.zpusobDopravaId) : null,
                        datumVyzvednuti: data.naPobocku ? data.datumVyzvednuti : null,
                        casVyzvednuti: data.naPobocku ? timeStringToDate(data.casVyzvednuti) : null,
                        datumDoruceni: !data.naPobocku ? data.datumDoruceni : null,
                        terminDopravaId: !naPobocku ? data.terminDopravaId : null,
                        pobockaVznikId: data.pobockaVznikId ? parseInt(data.pobockaVznikId) : null,
                        adresaId: !data.naPobocku && data.adresa ? data.adresa.id : null,
                        ulice: !data.naPobocku ? data.ulice : null,
                        obec: !data.naPobocku ? data.obec : null,
                        psc: !data.naPobocku ? data.psc : null,
                        stat: !data.naPobocku ? data.stat : null,
                    };
                    return ObjednavkaApi.updateObjednavkaDopravaPlatba(objednavka.id, result);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(objednavkaActions.invalidateObjednavka(objednavka.id));
                    objednavkaActions.notifyIfNeeded(result);
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: initialValues,
                adresyList: adresyList,
                zpusobyDopravyList: zpusobyDopravyList.rows,
                zpusobyPlatbyList: zpusobyPlatbyList.rows,
                pobockyList: pobockyList.rows,
                zobrazovatCasOd: getMinimalniCas(firmaDetail.data, pobocka, objednavka.datumVyzvednuti),
                zobrazovatCasDo: getMaximalniCas(firmaDetail.data),
                krokCasMinut: firmaDetail.data.krokCasMinut ? firmaDetail.data.krokCasMinut : TIME_STEP,
            },
            t('order.delivery_payment_edit'),
            {size: "lg"}
        ));
    };

    handleZalozitDopravu = () => {
        const {objednavka, t} = this.props;

        this.props.dispatch(modal.ModalActions.show(
            ObjednavkaDopravyForm,
            {
                onSubmit: (data) => {
                    return ObjednavkaApi.createObjednavkaDoprava(objednavka.id, data);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(objednavkaActions.invalidateObjednavka(objednavka.id));
                    dispatch(objednavkaActions.invalidateObjednavkaRights(objednavka.id));
                    objednavkaActions.notifyIfNeeded(result);
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
            },
            t('order.delivery_order'),
            {size: "md"}
        ));
    };

    handleTiskStitku = () => {
        const {objednavka, t} = this.props;
        window.open(`${serverContextPath}/api/cgo/objednavka/${objednavka.id}/objednavkadoprava/tiskStitky`, "_blank");
        this.props.dispatch(
            modal.ModalActions.showConfirm(
                t('order.label_print'),
                t('order.label_print_success'),
                () => {
                    ObjednavkaApi.tiskDopravaStitkyBalikyOk(objednavka.id).then(() => {
                        this.props.dispatch(objednavkaActions.invalidateObjednavka());
                        this.props.dispatch(objednavkaActions.invalidateObjednavkaRights());
                    });
                },
                null,
                t('yes'),
                t('no')
            )
        );
    };

    renderActions = () => {
        const {objednavkaRightsDetail, t} = this.props;
        const objednavkaRights = objednavkaRightsDetail.data;
        return <ButtonToolbar>
            {objednavkaRights.editObjDopravaPlatba && <Button onClick={this.handleUpravit}>{t('edit')}</Button>}
            {objednavkaRights.evDopravaZaloz && <Button onClick={this.handleZalozitDopravu}>{t('order.delivery_order_action')}</Button>}
            {objednavkaRights.evDopravaTiskStitku && <Button onClick={this.handleTiskStitku}>{t('order.label_print')}</Button>}
        </ButtonToolbar>;
    };

    render() {
        const {zpusobyDopravyList, zpusobyPlatbyList, pobockyList, adresyUzivatelList, objednavkaRightsDetail, t} = this.props;
        const objednavka = this.props.objednavka;

        if (!zpusobyDopravyList.fetched || !zpusobyPlatbyList.fetched || !pobockyList.fetched ||
            !adresyUzivatelList.fetched || !objednavkaRightsDetail.fetched) {
            return <Loader/>;
        }

        const zpusobDopravy = zpusobyDopravyList.rows.find(z => z.id === objednavka.zpusobDopravaId);
        const pobocka = zpusobDopravy.formaDoruceni === EnumFormaDoruceni.POB ? pobockyList.rows.find(p => p.id === objednavka.pobockaVznikId) : null;
        const {ulice, obec, psc, stat} = pobocka ? pobocka : objednavka;

        const typDopravy = <Col xs={4}>
            <DetailValue label={t('order.delivery_method')}>{objednavka.zpusobDopravaNazev}</DetailValue>
        </Col>;
        const typPlatby = <Col xs={4}>
            <DetailValue label={t('order.payment_method')}>{objednavka.zpusobPlatbaNazev}</DetailValue>
        </Col>;

        let content;
        if (zpusobDopravy.formaDoruceni === EnumFormaDoruceni.POB) {
            const datumCas = objednavka.datumVyzvednuti && objednavka.casVyzvednuti ? `${formatDate(objednavka.datumVyzvednuti)} ${t('after').toLowerCase()} ${formatTime(objednavka.casVyzvednuti)}` : null;
            content = <Row>
                {typDopravy}
                <Col xs={4}>
                    <DetailValue label={t('branch')}>{getUplnaAdresa({ulice, obec, psc, stat})}</DetailValue>
                </Col>
                <Col xs={4}>
                    <DetailValue label={t('order.date_and_time_of_pickup')}>{datumCas}</DetailValue>
                </Col>
                {typPlatby}
            </Row>
        } else {
            const casString = objednavka.terminDopravaCasDoruceniOd && objednavka.terminDopravaCasDoruceniDo ? `${t('between').toLowerCase()} ${formatTime(objednavka.terminDopravaCasDoruceniOd)} ${t('and').toLowerCase()} ${formatTime(objednavka.terminDopravaCasDoruceniDo)}` : null;
            const datumCas = `${objednavka.datumDoruceni ? `${formatDate(objednavka.datumDoruceni)}` : ""}${casString ? `, ${casString}` : ""}`;
            content = <Row>
                {typDopravy}
                <Col xs={4}>
                    <DetailValue label={t('address.title_one')}>{getUplnaAdresa({ulice, obec, psc, stat})}</DetailValue>
                </Col>
                <Col xs={4}>
                    <DetailValue label={t('order.date_and_time_of_delivery')}>{datumCas}</DetailValue>
                </Col>
                {typPlatby}
                <Col xs={4}>
                    <DetailValue label={t('order.delivery_order_number')}>{objednavka.extCisloObjDoprava}</DetailValue>
                </Col>
            </Row>
        }

        return <Card>
            <CardHeader>
                <ActionsRow actions={this.renderActions()}>
                    <h2>{t('order.delivery_and_payment')}</h2>
                </ActionsRow>
            </CardHeader>
            <CardBody>
                {content}
            </CardBody>
        </Card>
    }
}

function mapStateToProps(state) {
    return {
        firmaDetail: utils.storeFromArea(state, ciselnikActions.FIRMA_AREA),
        zpusobyDopravyList: utils.storeFromArea(state, ciselnikActions.ZPUSOBY_DOPRAVY_LIST_AREA),
        zpusobyPlatbyList: utils.storeFromArea(state, ciselnikActions.ZPUSOBY_PLATBY_LIST_AREA),
        pobockyList: utils.storeFromArea(state, ciselnikActions.POBOCKY_OPERATOR_LIST_AREA),
        adresyUzivatelList: utils.storeFromArea(state, objednavkaActions.OBJEDNAVKA_UZIVATEL_ADRESY_AREA),
        adresySpolecnostList: utils.storeFromArea(state, objednavkaActions.OBJEDNAVKA_SPOLECNOST_ADRESY_AREA),
        terminyDopravyList: utils.storeFromArea(state, ciselnikActions.TERMINY_DOPRAVY_LIST_AREA),
        objednavkaRightsDetail: storeFromArea(state, objednavkaActions.OBJEDNAVKA_RIGHTS_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(DopravaPlatbaPanel));
